import { Suspense, lazy } from 'react';

import { Permission } from '@bookora/shared';
import { PageFallback } from '@bookora/ui';
import type { RouteObject } from 'react-router-dom';

import { RequirePermission } from '@/app/require-permission';
import { RouteErrorBoundary } from '@/components/route-error-boundary';

const LandingPage = lazy(() => import('./landing-page'));
const JobPage = lazy(() => import('./job-page'));

function guarded(element: React.ReactNode): React.ReactElement {
  return (
    <RequirePermission anyOf={[Permission.IMPORT_AI]}>
      <Suspense fallback={<PageFallback />}>{element}</Suspense>
    </RequirePermission>
  );
}

/**
 * «ثبت اطلاعات از روی عکس».
 *
 *   /import/photo            kind picker, resume banner and history; with
 *                            `?kind=<KIND>`, the capture screen for that kind
 *   /import/photo/:jobId     one import: processing, review, result
 *
 * No sidebar section: the entry points live on the screens whose records they
 * fill (patients, expenses, tariffs, inventory, calendar). Each leaf carries
 * its own permission gate and error boundary, per the contract in `router.tsx`.
 */
export const routes: RouteObject[] = [
  {
    path: 'import/photo',
    element: guarded(<LandingPage />),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: 'import/photo/:jobId',
    element: guarded(<JobPage />),
    errorElement: <RouteErrorBoundary />,
  },
];

export default routes;
